<main id="db-wrapper">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation></app-only-admin-navigation>
    </div>

    <div class="container-fluid p-4" *ngIf="loading">
      <app-header-spinner>

      </app-header-spinner>
      <app-form-spinner></app-form-spinner>
    </div>
    <div class="container-fluid p-4" *ngIf="!loading">
      <div class="row">
        <div class="col-xl-12 mb-3 col-md-12 col-12">
          <div class="bg-primary py-4  px-xl-0 rounded-4 ">
            <div class="row align-items-center">
              <div class="offset-xl-1 col-xl-5 col-md-6 col-12">
                <div>
                  <h3 class="h3 text-white mb-3 px-5">User Messages from Contact Form</h3>
                </div>
              </div>
              <div class="col-xl-6 col-md-6 col-12">
                <div class="text-center">
                  <i class="bi bi-chat" style="font-size: 48px;">
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <!-- Card -->
          <div class="card mb-4">
            <!-- Card Header -->
            <div class="card-header d-lg-flex align-items-center justify-content-between">
              <div class="mb-3 mb-lg-0">
                <h3 class="mb-0">Messages</h3>
                <span>Messages from Contact Page</span>
              </div>
              <div>

              </div>
            </div>
            <!-- Card Body -->
            <div class="card-body">

              <ul class="list-group list-group-flush border-top">
                <p-table [value]="sessionDataArray" [tableStyle]="{'min-width': '60rem'}">
                  <ng-template pTemplate="header">
                    <tr>
                      <th pSortableColumn="name" style="width:25%">Name <p-sortIcon field="name"></p-sortIcon></th>
                      <th pSortableColumn="email" style="width:25%">Email <p-sortIcon field="email"></p-sortIcon></th>
                      <th style="width:25%">Description</th>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rev>
                    <tr>
                      <td>
                        <div class="d-flex align-items-center">
                          <span class="avatar avatar avatar-primary rounded-circle">
                            <span class="avatar-initials rounded-circle text-white">{{rev.name.charAt(0)}}</span>
                          </span>
                          <div class="ms-3 mt-2">
                            <h4 class="mb-0">{{rev.name}}</h4>
                          </div>
                        </div>
                      </td>

                      <td>{{rev.email}}</td>
                      <td>
                        <div class="mt-5" [innerHTML]="rev.description" id="richText"></div>
                      </td>

                    </tr>
                  </ng-template>
                </p-table>



              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>

  </section>
</main>
